<ion-header>
  <ion-toolbar>
    <ion-title>payment-summary</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content></ion-content>
